module.exports = __webpack_public_path__ + "static/img/005.7350845.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/005.png
// module id = Pm1e
// module chunks = 1